import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../../App.module.css';
import { POTENTIAL_PAYOUT_ROUTE } from '../constants/PotentialPayoutConstants';
import Description from '../components/PotentialPayoutSystemDescription';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import TestBlock from 'components/layout/test-block/TestBlock';
import { UtilsTypes } from 'constants/utilsTypes';
import { PotentialPayoutSystemParamsTypeSchema } from '@kambi/betting-client-helpers';

const GetPotentialPayoutSystem = () => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate(`/${POTENTIAL_PAYOUT_ROUTE}`)}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>Potential Payout System</div>
                <div className={classes.Main}>
                    <Description />
                    <Divider />
                    <CodeBlock
                        title="General input for the getPotentialPayoutSystem method"
                        initialDisplayedCode={`
    {
        "selectedOutcomes": [
            {
                "id": 2952049917,
                "odds": 1100,
                "nrOfPermutations": 2,
                "betOfferId": 300
            },
            {
                "id": 2952070553,
                "odds": 1970,
                "betOfferId": 2280699976
            }
        ],`}
                        moreCode={`
        "hasBetErrors":false,
        "hasBetBuilders": false,
        "translations": {"payoutNotAvailableTranslation":"custom translation for payout not available"},
        "stakes": [
            {
                "stake": 3,
                "toWinInput": 100,
                "eachWaySelected": false,
                "systemType": "double",
				"type": ""
            }
        ],
        "selectedReward": {
            "isFreeBet": true,
            "freeBetAmount": 100000
        },
        "betOffers": []
    }`}
                    />
                    <TestBlock
                        validationSchema={PotentialPayoutSystemParamsTypeSchema}
                        title="You can test the getPotentialPayoutSystem() method by adding the input parameters as
                a JSON object in the below textarea, click Run and check the
                Output in the right"
                        type={UtilsTypes.POTENTIAL_PAYOUT_SYSTEM}
                    />
                </div>
            </div>
        </div>
    );
};

export default GetPotentialPayoutSystem;
